import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';

const MidAccordionItem = ({ data = {}, changeInput, changeMaxSeats }) => {
  const changeHandler = () => {
    changeInput(data, data.optionId, !data.selected);
  };
  const handleChange = data => {
    changeMaxSeats(data);
  };
  useEffect(() => {
    if (!data.selected && !data.isAnyChildSelected) {
      data.maxSeats = '';
    }
  }, [data.selected, data.isAnyChildSelected]);
  return (
    <Fragment>
      <div
        className={
          data.isAnyChildSelected
            ? 'ent-table-row-product isAnyItemSelected'
            : 'ent-table-row-product'
        }
      >
        <input
          type="checkbox"
          name="oprtionName"
          key={Math.random()}
          id={data.optionId}
          disabled={data.disable || data.optionId === 1}
          onChange={changeHandler}
          defaultChecked={data.selected}
        />
        <label
          disabled={data.disableText}
          htmlFor={data.optionId}
          title={data.optionName}
        >
          {data.optionName}
        </label>
      </div>
      {data.seatsRequired ? (
        <div className="ent-table-row-input">
          <input
            type="text"
            id={data.optionId}
            max="1000"
            onChange={event => {
              event.preventDefault();
              if (
                isNaN(Number(event.target.value)) ||
                parseInt(event.target.value) > parseInt(event.target.max)
              ) {
                return;
              } else {
                data[event.target.name] = event.target.value;
                handleChange(data);
              }
            }}
            maxLength="4"
            disabled={
              data.disable || !(data.selected || data.isAnyChildSelected)
            }
            value={data.maxSeats}
            name="maxSeats"
          />
        </div>
      ) : null}
    </Fragment>
  );
};
MidAccordionItem.propTypes = {
  data: PropTypes.shape({}),
  changeInput: PropTypes.func,
  changeMaxSeats: PropTypes.func,
};

export default React.memo(MidAccordionItem);
